import React from 'react';
import { motion } from 'framer-motion';

const About = ({ data }) => {
  return (
    <section className="py-20 px-6">
      <div className="container mx-auto max-w-6xl">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl lg:text-5xl font-bold text-stone-800 mb-6">
            {data.title}
          </h2>
          <p className="text-xl text-stone-600 max-w-3xl mx-auto">
            {data.subtitle}
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.2 }}
        >
          <div className="bg-white rounded-2xl p-8 border border-stone-200 shadow-lg">
            <div className="space-y-4 text-stone-700 leading-relaxed">
              <p>{data.summary}</p>
              <p>{data.paragraph2}</p>
              <p>{data.paragraph3}</p>
            </div>
          </div>
        </motion.div>

        {data.competencies.strategic.length > 0 && (
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.4 }}
            className="mt-12"
          >
            <div className="bg-stone-50 rounded-2xl p-8 border border-stone-200">
              <h3 className="text-2xl font-bold text-stone-800 mb-6">Expertise</h3>
              <ul className="grid md:grid-cols-2 gap-3">
                {data.competencies.strategic.map((item, index) => (
                  <li key={index} className="text-stone-700 flex items-start">
                    <span className="text-amber-600 mr-2">•</span>
                    <span>{item}</span>
                  </li>
                ))}
              </ul>
            </div>
          </motion.div>
        )}
      </div>
    </section>
  );
};

export default About;